/*
  商品詳細の画像カウンターと、シーンナビの現在地

  横スクロールする画像列の、いま見えている枚数を出す。
  「1 / 30」の 30 は Liquid が出すので、ここが触るのは現在値だけ。

  実装仕様
  #0 いま見えている画像に合わせて、右上の枚数と縦の目盛りを動かす。
     目盛りの長さはCSSが枚数から出す。ここが渡すのは 0〜1 の進み具合だけ
  #1 IntersectionObserver で、列の中で最も見えている画像を現在値にする。
     スクロールイベントで毎回計算すると、画像が多い商品で重くなる
  #2 threshold を刻んでいるのは、画像の幅が揃っていないため。
     交差比率で比べて最大のものを採る
  #3 shopify:section:load で作り直す。テーマエディタでの編集に追従する
  #4 IntersectionObserver が無い環境ではカウンターを出さない。
     1 のまま固定で出すと嘘になる
  #7 流れに出すのは先頭3段まで。残りはボタンで開く。
     畳むのはここの役目で、JSが動かない環境では全部出たままになる
  #6 マウスを乗せた画像を、段の相方の上に拡大して出す（2026-09-21 クライアント指定）。
     背景の大きさを100%より大きくしておき、背景位置をパーセントで渡す。
     こうすると割合がそのまま「画像のどこを見ているか」に対応し、
     画像の実寸を知らなくても位置が合う
  #11 枚数と目盛りの色を、下にある絵の明るさで決める（2026年9月23日 PM指定）。
     白のままだと明るい写真の上で消える。TECHNOLOGYの見出し
     （assets/custom tech hero.js）と同じやり方・同じ境目で、
     小さい画像を読み直して輝度を測り、暗ければ白・明るければブランドカラーにする
  #5 シーンナビは、いま画面の中央に近いシーンに aria current を付ける。
     PCは1回の操作で1シーンずつ送るので、押して飛ぶだけでなく
     指で送ったときも左の印が追いかける必要がある。
     交差の比率ではなく「画面の上寄りに入っているか」で見るのは、
     1画面ぶんの高さのシーンだと比率がほぼ同じになるため
*/
(function () {
  'use strict';

  var STORY = '[data-c-story]';
  var SCENE = '[data-c-story-scene]';
  var NAV = '[data-c-story-nav]';
  var RAIL = '[data-story-rail]';
  var FRAME = '[data-story-frame]';
  var COUNTER = '[data-story-counter]';
  var CURRENT = '[data-story-current]';
  var GALLERY = '[data-story-gallery]';
  var MORE = '[data-story-more]';
  /* 流れに出す段数 */
  var ROWS = 3;
  var ZOOM = '[data-story-zoom]';
  var ZOOM_SRC = 'data-story-zoom-src';
  var TRACK = '.c-story__track';
  var THUMB = '.c-story__thumb';
  /* つまみの下限。枚数が多いと点になって見えなくなる */
  var MIN_THUMB = 12;
  /* C案（2枚1組で送る）で足したもの */
  var LIVE = 'c-story--live';
  var STAGE = '[data-story-stage]';
  var STEPS_EL = '[data-story-steps]';
  var STEP = '[data-story-step]';
  var PANE = '[data-story-pane]';
  var LAYER = '.c-story__layer';
  var LENS = '[data-story-lens]';
  var ZOOM_IMAGE = '[data-story-zoom-image]';
  var PC = '(min-width: 1000px)';
  var HOVER = '(min-width: 1000px) and (pointer: fine)';
  /*
    Figma 730:3283。倍率は 554 / 180 = 3.078倍。
    面の幅は元画像と同じ535にする（2026年9月23日 PM指示）。
    倍率は面と枠の比なので、枠のほうを 535 / 3.078 に合わせれば3.078倍のまま。
    正はCSS（.c-story__zoom / .c-story__lens）で、ここは同じ式で持つ
  */
  var FIGMA_W = 535;
  var FIGMA_H = 714;
  var MAG = 554 / 180;
  var ZOOM_SIZE = FIGMA_W;
  var LENS_SIZE = ZOOM_SIZE / MAG;
  /*
    次の送りを受け付けるのは、フェードの長さのこの割合が過ぎたとき。実装仕様 #12
  */
  var SETTLE = 0.5;
  /* 次の絵の読み込みを待つ上限。回線が詰まっても送りが止まったままにならないように */
  var LOAD_WAIT = 3000;

  var GUIDE = '[data-story-guide]';
  var DIALOG = '[data-story-dialog]';
  var DIALOG_BODY = '[data-story-dialog-body]';
  var DIALOG_CLOSE = '[data-story-dialog-close]';
  var GUIDE_ROOT = '[data-size-guide]';

  function setup(root) {
    var rails = (root || document).querySelectorAll(RAIL);

    rails.forEach(function (rail) {
      var scene = rail.closest('.c-story__scene');
      var counter = scene && scene.querySelector(COUNTER);
      var current = counter && counter.querySelector(CURRENT);
      var frames = rail.querySelectorAll(FRAME);

      if (!current || !frames.length) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        counter.hidden = true;
        return;
      }

      var ratios = new Map();

      var observer = new IntersectionObserver(
        function (entries) {
          /*
            C案が動いているときは、現在値を Gallery が出す。
            こちらは3枚目以降が消えていて交差が起きず、
            窓2枚だけを見て1か2に固定してしまうので黙らせる
          */
          var story = rail.closest(STORY);

          if (story && story.classList.contains(LIVE)) {
            return;
          }

          entries.forEach(function (entry) {
            ratios.set(entry.target, entry.intersectionRatio);
          });

          var best = null;
          var bestRatio = 0;

          frames.forEach(function (frame) {
            var ratio = ratios.get(frame) || 0;

            if (ratio > bestRatio) {
              bestRatio = ratio;
              best = frame;
            }
          });

          if (!best) {
            return;
          }

          var index = [].indexOf.call(frames, best);
          current.textContent = String(index + 1);

          /*
            枚数の色も地に合わせる。実装仕様 #11。
            SPの画像は切り取らずそのまま出るので crop は false
          */
          var shown = best.querySelector('img');
          paintTone(counter, shown && shown.getAttribute('src'), false);

          /*
            縦の目盛りのつまみ。長さと位置を px で渡す。
            目盛りの長さの正はCSS側なので、ここは実寸を読んで計算するだけ。
            1枚しか無いときは割り算が 0/0 になるので 0 にする
          */
          var track = scene.querySelector(TRACK);
          var thumb = track && track.querySelector(THUMB);

          if (thumb) {
            var trackSize = track.getBoundingClientRect().height;
            var size = Math.max(MIN_THUMB, trackSize / frames.length);
            var span = frames.length > 1 ? index / (frames.length - 1) : 0;

            thumb.style.setProperty('--c-story-thumb-size', size + 'px');
            thumb.style.setProperty('--c-story-thumb-offset', span * (trackSize - size) + 'px');
          }
        },
        /*
          列の中ではなくページを基準にする（横送りをやめたため）。
          上から2〜3割の帯に入っている画像を「いま見ている」とみなす
        */
        { rootMargin: '-20% 0px -70% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
      );

      frames.forEach(function (frame) {
        observer.observe(frame);
      });
    });
  }

  /*
    先頭3段だけ出し、残りはボタンで開く。実装仕様 #7

    畳むのはここの役目。JSが動かない環境では全部出たままになる。
    隠しておいて開けなくなるより、長くても読めるほうがよい
  */
  function setupClamp(root) {
    (root || document).querySelectorAll(GALLERY).forEach(function (gallery) {
      var frames = [].slice.call(gallery.querySelectorAll(FRAME));
      var button = gallery.querySelector(MORE);

      if (!button || !frames.length) {
        return;
      }

      function capFor() {
        var wide = window.matchMedia && window.matchMedia('(min-width: 1000px)').matches;
        return ROWS * (wide ? 2 : 1);
      }

      function clamp() {
        var cap = capFor();

        if (frames.length <= cap) {
          frames.forEach(function (frame) {
            frame.hidden = false;
          });
          button.hidden = true;
          return;
        }

        frames.forEach(function (frame, i) {
          frame.hidden = i >= cap;
        });
        button.hidden = false;
      }

      function open() {
        frames.forEach(function (frame) {
          frame.hidden = false;
        });
        button.hidden = true;
      }

      button.addEventListener('click', open);
      clamp();

      /*
        PCとSPで1段の枚数が変わる。開いたあとは畳み直さない
        （読んでいる途中で消えると驚く）
      */
      if (window.matchMedia) {
        window.matchMedia('(min-width: 1000px)').addEventListener('change', function () {
          if (!button.hidden) {
            clamp();
          }
        });
      }
    });
  }

  /*
    メイン画像の送り（C案）。実装仕様 #8

    2枚で1組。入れ替えはトップのHEROと同じフェード（2026年9月24日 PM指示。
    それまでは縦送りだった）。左が先に変わり始め、右は CSS の transition-delay で
    180ms遅れて追う。

    窓（.c-story__pane）は1mmも動かさない。変わるのは中身の2層だけなので、
    送りの最中も着地後も2枚の隙間はゼロのまま崩れない。

    PCでJSが生きているときだけ .c-story--live を付ける。
    CSSのメディアクエリ単独で出し分けないのは、JSが無いPCに
    窓2つだけの壊れた形が出てしまうため。
  */
  /*
    地の明るさ。実装仕様 #11

    測り方は assets/custom luminance.js が持つ（サイト共通。境目も同じ0.55）。
    ここが決めるのは「どの絵の、どこを見るか」だけ。

    枚数が乗っているのは右上なので、右上4分の1を見る。
    PCの窓は object fit cover なので、絵の端は切り取られて見えていない。
    切り取ったあとの範囲に読み替えてから測る（crop が false のときは切り取りが無い）
  */
  function paintTone(meter, src, crop) {
    var lum = window.cLuminance;

    if (!meter) {
      return;
    }

    if (!lum || !src) {
      meter.setAttribute('data-tone', 'light');
      return;
    }

    /* 測っているあいだに絵が変わったら、あとから来たほうが正しい */
    meter.setAttribute('data-story-tone-src', src);

    lum.grid(src, function (table) {
      if (meter.getAttribute('data-story-tone-src') !== src) {
        return;
      }

      var value = crop
        ? lum.inBox(table, FIGMA_W / FIGMA_H, 0.75, 0, 1, 0.25)
        : lum.average(table, 0.75, 0, 1, 0.25);

      meter.setAttribute('data-tone', value < lum.LIGHT_LIMIT ? 'dark' : 'light');
    });
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* 1つの層に1枚ぶんの情報を写す。sizes を srcset より先に入れること */
  function applyShot(img, shot) {
    if (!shot) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('src');
      img.alt = '';
      return;
    }

    if (shot.sizes) {
      img.setAttribute('sizes', shot.sizes);
    } else {
      img.removeAttribute('sizes');
    }

    if (shot.srcset) {
      img.setAttribute('srcset', shot.srcset);
    } else {
      img.removeAttribute('srcset');
    }

    img.setAttribute('src', shot.src);
    img.alt = shot.alt || '';
  }

  /*
    CSSの時間（'1800ms' / '1.8s' / '.18s'）をミリ秒にする。
    **配信中のCSSは Shopify が圧縮していて、1800ms は 1.8s に、180ms は .18s に書き換わる。**
    parseFloat だけだと 1.8 と 0.18 になり、待ち時間が1000分の1に縮む
    （2026年9月29日 実環境で発覚。受け付けまでの時間が約1.1秒のはずが約41msになっていた。
    検証ページは圧縮前のCSSを読むので気づけなかった）
  */
  function toMs(value, fallback) {
    var text = String(value || '').trim();
    var number = parseFloat(text);

    if (isNaN(number)) {
      return fallback;
    }

    return /ms$/.test(text) ? number : /s$/.test(text) ? number * 1000 : number;
  }

  /*
    層に写した絵が描ける状態になるまで待つ。
    読み込み前にフェードを始めると、前の絵が消えていくのに次の絵が来ず、
    窓の地（白）へ抜けてから絵が遅れて出る。失敗しても送りは止めない
  */
  function whenReady(img, shot) {
    if (!shot || typeof img.decode !== 'function') {
      return Promise.resolve();
    }

    return Promise.race([
      img.decode().catch(function () {}),
      new Promise(function (resolve) {
        setTimeout(resolve, LOAD_WAIT);
      })
    ]);
  }

  function Gallery(root) {
    var self = this;

    this.root = root;
    this.story = root.closest(STORY);
    this.stage = root.querySelector(STAGE);
    this.grid = root.querySelector(RAIL);
    this.stepsEl = root.querySelector(STEPS_EL);
    this.steps = [].slice.call(root.querySelectorAll(STEP));
    this.frames = [].slice.call(root.querySelectorAll(FRAME));
    this.lens = root.querySelector(LENS);
    this.zoom = root.querySelector(ZOOM);
    this.zoomImage = root.querySelector(ZOOM_IMAGE);

    var counter = root.querySelector(COUNTER);
    this.meterEl = counter;
    this.current = counter && counter.querySelector(CURRENT);
    /* 要素はメソッド名と衝突しないよう El を付ける（track は拡大の追従メソッド） */
    this.trackEl = root.querySelector(TRACK);
    this.thumbEl = this.trackEl && this.trackEl.querySelector(THUMB);

    /*
      窓に写す前に全部の絵を控える。ここを取り損ねると、
      PCからSPへ戻したときに1枚目へ別の絵が残る
    */
    this.shots = this.frames.map(function (frame) {
      var img = frame.querySelector('img');

      if (!img) {
        return null;
      }

      return {
        src: img.getAttribute('src'),
        srcset: img.getAttribute('srcset'),
        sizes: img.getAttribute('sizes'),
        alt: img.getAttribute('alt'),
        zoom: frame.getAttribute(ZOOM_SRC)
      };
    });

    this.panes = [].slice.call(root.querySelectorAll(PANE)).map(function (el, i) {
      return {
        el: el,
        layers: [].slice.call(el.querySelectorAll(LAYER)),
        front: 0,
        index: i,
        armed: false
      };
    });

    this.step = 0;
    this.live = false;
    this.busy = false;
    this.pending = null;
    this.timer = 0;
    /* 読み込み待ちのあいだに作り直されたら、待っていた送りを捨てるための番号 */
    this.seq = 0;
    this.hoverPane = -1;
    this.rects = null;
    this.lastEv = null;
    this.rafId = 0;

    this.onScroll = function () {
      self.update();
    };
    this.onResize = function () {
      self.invalidate();
      self.sync();
    };

    this.bindHover();
    this.sync();

    window.addEventListener('resize', this.onResize);

    if (window.matchMedia) {
      this.mql = window.matchMedia(PC);

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onResize);
      }
    }
  }

  Gallery.prototype.usable = function () {
    return !!(
      this.story &&
      this.stage &&
      this.grid &&
      this.stepsEl &&
      this.steps.length &&
      this.panes.length === 2 &&
      this.panes[0].layers.length === 2 &&
      this.panes[1].layers.length === 2
    );
  };

  Gallery.prototype.sync = function () {
    var want = !!(window.matchMedia && window.matchMedia(PC).matches) && this.usable();

    if (want === this.live) {
      if (this.live) {
        this.invalidate();
        this.update();
      }
      return;
    }

    this.live = want;
    this.story.classList.toggle(LIVE, want);

    if (want) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      /* 初回は動かさずに置く。読み込み直後に絵が滑ると驚く */
      this.step = -1;
      this.update();
    } else {
      window.removeEventListener('scroll', this.onScroll);
      this.reset();
    }
  };

  Gallery.prototype.invalidate = function () {
    this.rects = null;
  };

  /* 1組ぶんのスクロール量。正はCSSの --c-story-step */
  Gallery.prototype.stepSize = function () {
    return this.steps.length ? this.steps[0].getBoundingClientRect().height : 0;
  };

  /*
    スクロール位置から何組目かを出す。実装仕様 #9

    交差監視ではなく帯の位置から直接出す。停止位置に着地したとき
    ちょうど整数になるので、画面の高さにも帯の高さにも左右されない
  */
  Gallery.prototype.update = function () {
    if (!this.live) {
      return;
    }

    var size = this.stepSize();

    if (!size) {
      return;
    }

    var top = parseFloat(getComputedStyle(this.stage).top) || 0;
    var progress = (top - this.stepsEl.getBoundingClientRect().top) / size;
    var index = Math.max(0, Math.min(this.steps.length - 1, Math.round(progress)));

    this.goTo(index);
  };

  /*
    その組が出す2枚。実装仕様 #10

    素直に2枚ずつ切ると、奇数枚のときだけ最後の組の右が空になり、
    窓の地だけが残って画像が抜け落ちたように見える（2026年9月23日 PM指摘）。
    最後の組は「左＝最後から2枚目・右＝最後の1枚」へずらす。
    最後から2枚目が2組続けて出る（右の窓から左の窓へ移る）が、
    左右に同じ絵が並ぶことも、空の窓が出ることも無い。

    枚数が1枚しか無い商品だけは組が作れないので、右は空のまま
  */
  Gallery.prototype.pairFor = function (step) {
    var last = this.shots.length - 1;
    var left = step * 2;
    var right = left + 1;

    if (right > last) {
      right = last;
      left = last - 1;
    }

    if (left < 0) {
      left = 0;
      right = -1;
    }

    return [left, right];
  };

  Gallery.prototype.goTo = function (step) {
    if (step === this.step) {
      return;
    }

    if (this.busy) {
      this.pending = step;
      return;
    }

    var first = this.step < 0;
    var self = this;
    var pair = this.pairFor(step);

    this.step = step;
    this.paint(step, pair[0]);

    /* 送りのあいだ拡大は出さない。変わっている途中の絵を3倍にしても読めない */
    this.hideZoom();

    var ready = [this.prepare(this.panes[0], pair[0]), this.prepare(this.panes[1], pair[1])];

    if (first) {
      this.swap(this.panes[0], true);
      this.swap(this.panes[1], true);
      this.tone(pair[1]);
      return;
    }

    this.busy = true;
    clearTimeout(this.timer);

    /*
      左右とも読み込めてから一緒に始める。片方ずつ始めると
      読み込みの速さで順番が入れ替わり、右が先に変わることがある
    */
    var seq = ++this.seq;

    Promise.all(ready).then(function () {
      if (seq !== self.seq) {
        return;
      }

      self.swap(self.panes[0], false);
      self.swap(self.panes[1], false);
      self.timer = setTimeout(land, self.sendTime());
    });

    function land() {
      self.busy = false;

      if (self.pending !== null && self.pending !== self.step) {
        var next = self.pending;
        self.pending = null;
        self.goTo(next);
        return;
      }

      self.pending = null;

      /*
        色は着地してから変える。送りの最中に変えると、
        まだ画面に残っている前の絵と色が合わない時間が長くなる
      */
      self.tone(self.pairFor(self.step)[1]);

      /*
        着地したら拡大を戻す。次の mousemove を待つと、
        マウスを止めたまま送りが終わった人には二度と戻らない
      */
      if (self.hoverPane >= 0 && self.lastEv) {
        self.invalidate();
        self.track(self.lastEv);
      }
    }
  };

  /*
    次の送りを受け付けるまでの時間。正はCSSの2つの変数。実装仕様 #12

    フェードが終わりきるのは 長さ＋遅れ（1800＋180ms）だが、そこまでは待たない。
    イージングが --motion-ease（入りが速く終わりが静かな out 系）なので、
    長さの半分で96%まで入れ替わっていて、残りは目に見えない尾でしかない。
    尾まで待つと、続けてスクロールしても2秒近く絵が変わらない。
    半分で受け付け、下にまだ薄く残っている前の絵（4%以下）は次の仕込みでその場で消す
  */
  Gallery.prototype.sendTime = function () {
    var cs = getComputedStyle(this.root);
    var dur = toMs(cs.getPropertyValue('--c-story-send-duration'), 1800);
    var lag = toMs(cs.getPropertyValue('--c-story-send-lag'), 180);

    return dur * SETTLE + lag + 40;
  };

  /*
    1つの窓の裏の層に次の絵を仕込む。返すのは、絵が描ける状態になるのを待つ約束。
    仕込んだ層は透明のまま上に置いておき、swap で出す。
    1枚の src を差し替えると読み込みの瞬間に絵が消えて点滅するので、必ず2層でやる。
    index が -1 のとき（画像が1枚しか無い商品の右）は空のまま出す
  */
  Gallery.prototype.prepare = function (pane, index) {
    if (pane.index === index) {
      pane.armed = false;
      return Promise.resolve();
    }

    pane.index = index;
    pane.armed = true;

    var shot = this.shots[index] || null;
    var next = pane.layers[1 - pane.front];
    var prev = pane.layers[pane.front];

    next.style.transition = 'none';
    next.style.opacity = '0';
    next.style.zIndex = '2';
    prev.style.zIndex = '1';

    /*
      右の窓に最初から入っている層は loading lazy を持っている（2枚目の画像）。
      画面の外で仕込むと読み込みが始まらず、待ちが上限まで延びる
    */
    next.removeAttribute('loading');
    applyShot(next, shot);

    return whenReady(next, shot);
  };

  /*
    仕込んだ層を出す。HEROと同じく、新しい絵が上で現れ、下で前の絵が消えていく。
    instant のときは時間をかけずに入れ替える（読み込み直後に絵が変わると驚く）
  */
  Gallery.prototype.swap = function (pane, instant) {
    if (!pane.armed) {
      return;
    }

    pane.armed = false;

    var next = pane.layers[1 - pane.front];
    var prev = pane.layers[pane.front];

    if (instant) {
      prev.style.transition = 'none';
    } else {
      /* 透明で置いた状態を一度確定させてから transition を戻す。戻さないとフェードにならない */
      void next.offsetWidth;
      next.style.transition = '';
    }

    next.style.opacity = '1';
    prev.style.opacity = '0';

    if (instant) {
      /* ここで一度確定させてから transition を戻す。戻さないと次の送りが効かない */
      void next.offsetWidth;
      next.style.transition = '';
      prev.style.transition = '';
    }

    pane.front = 1 - pane.front;
  };

  /*
    カウンタとつまみ。カウンタは組の左側の枚数を出す
    （01 / 30 から 03 / 30 と進んで 29 / 30 で終わる）。
    奇数枚のときは最後の組だけ1つずれるので、組の番号からではなく
    実際に左の窓へ出している枚数（left）から出す。
    つまみの長さと位置は px で渡す。目盛りの長さの正はCSS側で、
    ここは実寸を読んで計算するだけ
  */
  Gallery.prototype.paint = function (step, left) {
    if (this.current) {
      this.current.textContent = pad2(left + 1);
    }

    if (!this.thumbEl || !this.trackEl) {
      return;
    }

    var trackSize = this.trackEl.getBoundingClientRect().height;
    var count = this.steps.length;
    var size = Math.max(MIN_THUMB, trackSize / count);
    var span = count > 1 ? step / (count - 1) : 0;

    this.thumbEl.style.setProperty('--c-story-thumb-size', size + 'px');
    this.thumbEl.style.setProperty('--c-story-thumb-offset', span * (trackSize - size) + 'px');
  };

  /*
    枚数と目盛りの色。実装仕様 #11

    乗っているのは右の窓なので、そこに出している絵だけを見る。
    絵が無い（画像が1枚しか無い商品の右）ときは窓の地＝明るい扱い
  */
  Gallery.prototype.tone = function (index) {
    var shot = this.shots[index];

    paintTone(this.meterEl, shot && shot.src, true);
  };

  /* SPへ戻したときに窓を元の2枚へ戻す */
  Gallery.prototype.reset = function () {
    var self = this;

    this.hideZoom();
    clearTimeout(this.timer);
    this.seq++;
    this.busy = false;
    this.pending = null;

    this.panes.forEach(function (pane, i) {
      pane.layers.forEach(function (layer) {
        layer.style.transition = 'none';
        layer.style.opacity = '';
        layer.style.zIndex = '';
      });

      applyShot(pane.layers[0], self.shots[i]);
      applyShot(pane.layers[1], null);
      pane.front = 0;
      pane.index = i;
      pane.armed = false;

      void pane.el.offsetWidth;

      pane.layers.forEach(function (layer) {
        layer.style.transition = '';
      });
    });

    this.step = 0;

    if (this.current) {
      this.current.textContent = '01';
    }

    /* 色の判定はSP側（setup）が引き継ぐ。ここでは持ち越さない */
    if (this.meterEl) {
      this.meterEl.removeAttribute('data-tone');
      this.meterEl.removeAttribute('data-story-tone-src');
    }
  };

  /*
    ホバー拡大。実装仕様 #6

    カーソルの下に180x180の枠を出し、その中身を 554/180 倍にして
    隣の窓の上に554x554で出す。面の下端は元画像の下端に揃う。
    寸法はCSSが --c-story-unit（いまの1 Figma px）から出すので、
    ここが渡すのはその1つと、動く位置だけ
  */
  Gallery.prototype.measure = function () {
    this.rects = {
      grid: this.grid.getBoundingClientRect(),
      pane: [this.panes[0].el.getBoundingClientRect(), this.panes[1].el.getBoundingClientRect()]
    };
  };

  Gallery.prototype.hideZoom = function () {
    if (this.lens) {
      this.lens.removeAttribute('data-on');
    }

    if (this.zoom) {
      this.zoom.removeAttribute('data-on');
    }
  };

  Gallery.prototype.track = function (ev) {
    if (!this.live || this.busy || this.hoverPane < 0 || !ev) {
      this.hideZoom();
      return;
    }

    /*
      発火のたびに見る。読み込み時に1回だけ判定すると、
      幅を行き来したときに出っぱなしになったり一生出なくなったりする
    */
    if (!window.matchMedia || !window.matchMedia(HOVER).matches) {
      this.hideZoom();
      return;
    }

    if (!this.lens || !this.zoom || !this.zoomImage) {
      return;
    }

    if (!this.rects) {
      this.measure();
    }

    var pr = this.rects.pane[this.hoverPane];
    var other = this.rects.pane[1 - this.hoverPane];
    var gr = this.rects.grid;

    if (!pr.width || !pr.height) {
      return;
    }

    var shot = this.shots[this.panes[this.hoverPane].index];

    if (!shot) {
      this.hideZoom();
      return;
    }

    var unit = pr.width / FIGMA_W;
    var half = (LENS_SIZE / 2) * unit;
    var surf = ZOOM_SIZE * unit;

    /* 枠が窓からはみ出さないよう端で止める */
    var cx = Math.min(Math.max(ev.clientX - pr.left, half), pr.width - half);
    var cy = Math.min(Math.max(ev.clientY - pr.top, half), pr.height - half);

    this.grid.style.setProperty('--c-story-unit', unit + 'px');

    this.lens.style.left = pr.left + cx - half - gr.left + 'px';
    this.lens.style.top = pr.top + cy - half - gr.top + 'px';

    /* 面は隣の窓の上。左にホバーなら右の左端から、右なら左の右端まで */
    this.zoom.style.left =
      (this.hoverPane === 0 ? other.left - gr.left : other.right - gr.left - surf) + 'px';
    /* 下端を元画像の下端に揃える（Figma 730:3283 の関係） */
    this.zoom.style.top = pr.bottom - surf - gr.top + 'px';

    /* 枠の中心が面の中心に来るよう、拡大した絵をずらす */
    this.zoomImage.style.transform =
      'translate(' + (surf / 2 - cx * MAG) + 'px,' + (surf / 2 - cy * MAG) + 'px)';

    var src = shot.zoom || shot.src;

    if (this.zoomImage.getAttribute('src') !== src) {
      this.zoomImage.setAttribute('src', src);
    }

    this.lens.setAttribute('data-on', '');
    this.zoom.setAttribute('data-on', '');
  };

  Gallery.prototype.bindHover = function () {
    var self = this;

    this.panes.forEach(function (pane, i) {
      pane.el.addEventListener('mouseenter', function () {
        self.hoverPane = i;
        self.invalidate();
      });

      pane.el.addEventListener('mouseleave', function () {
        if (self.hoverPane === i) {
          self.hoverPane = -1;
        }
        self.hideZoom();
      });
    });

    if (!this.grid) {
      return;
    }

    this.grid.addEventListener(
      'mousemove',
      function (ev) {
        self.lastEv = ev;

        if (self.rafId) {
          return;
        }

        self.rafId = requestAnimationFrame(function () {
          self.rafId = 0;
          self.track(self.lastEv);
        });
      },
      { passive: true }
    );
  };

  Gallery.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);

    if (this.mql && this.mql.removeEventListener) {
      this.mql.removeEventListener('change', this.onResize);
    }

    clearTimeout(this.timer);
    this.seq++;

    if (this.live) {
      this.live = false;
      this.story.classList.remove(LIVE);
      this.reset();
    }
  };

  var galleries = [];

  function setupGallery(root) {
    /* 作り直す前に前の分を必ず片付ける。でないとスクロールの購読が積み上がる */
    for (var i = 0; i < galleries.length; i++) {
      galleries[i].destroy();
    }

    galleries = [];

    document.querySelectorAll(GALLERY).forEach(function (el) {
      galleries.push(new Gallery(el));
    });
  }

  /* いま見ているシーンを左のナビに映す。実装仕様 #5 */
  function markCurrent(root) {
    (root || document).querySelectorAll(STORY).forEach(function (story) {
      var scenes = story.querySelectorAll(SCENE);
      var links = story.querySelectorAll(NAV);

      if (!scenes.length || !links.length || !('IntersectionObserver' in window)) {
        return;
      }

      /*
        シーンとナビは1対1ではない。1枚目（商品画像）にはナビが無いので、
        並び順で数えるとひとつずつずれる。リンクの飛び先でシーンを引き当てる
      */
      function linkFor(scene) {
        var hit = null;
        links.forEach(function (link) {
          if (link.getAttribute('href') === '#' + scene.id) {
            hit = link;
          }
        });
        return hit;
      }

      function show(scene) {
        var target = scene && linkFor(scene);
        links.forEach(function (link) {
          if (link === target) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }
            show(entry.target);
          });
        },
        /*
          上端から少し下に判定の線を引く。追従しているものの下に
          入ってきたシーンを「見ている」とみなす
        */
        { rootMargin: '-20% 0px -70% 0px' }
      );

      scenes.forEach(function (scene) {
        observer.observe(scene);
      });

      /* 最初はどのシーンも通り過ぎていないので、印は付けない */
      show(null);
    });
  }

  /*
    サイズガイドのポップアップ。実装仕様 #7。
    リンク先のページを1回だけ取得し、data size guide の中身を dialog に差し込む。
    取得に失敗したら普通のリンクとして遷移させる（中身の無い面を開かない）
  */
  function setupGuide(root) {
    var links = (root || document).querySelectorAll(GUIDE);

    links.forEach(function (link) {
      var scene = link.closest('.c-story__scene');
      var dialog = scene && scene.querySelector(DIALOG);

      /* dialog を持たないブラウザではリンクのまま。ページへ飛ぶ */
      if (!dialog || typeof dialog.showModal !== 'function') {
        return;
      }

      var body = dialog.querySelector(DIALOG_BODY);
      var closeButton = dialog.querySelector(DIALOG_CLOSE);
      var loaded = false;
      var loading = false;

      /*
        取得したページの見出しを1段下げる。ページでは h1 だが、
        商品詳細の中では商品名が h1 なので、面の中の見出しは h2 から始める
      */
      function demote(fragment) {
        ['h3', 'h2', 'h1'].forEach(function (tag) {
          fragment.querySelectorAll(tag).forEach(function (el) {
            var next = document.createElement('h' + (Number(tag.charAt(1)) + 1));
            Array.prototype.forEach.call(el.attributes, function (attr) {
              next.setAttribute(attr.name, attr.value);
            });
            while (el.firstChild) {
              next.appendChild(el.firstChild);
            }
            el.parentNode.replaceChild(next, el);
          });
        });
      }

      function load() {
        if (loaded || loading) {
          return;
        }
        loading = true;
        body.setAttribute('aria-busy', 'true');

        fetch(link.href, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var guide = doc.querySelector(GUIDE_ROOT);
            if (!guide) {
              throw new Error('no size guide');
            }
            /* セクションの包みごと取る。中の style がその包みの id に掛かっている */
            var section = guide.closest('.shopify-section') || guide;
            demote(section);
            body.replaceChildren(document.adoptNode(section));
            loaded = true;
          })
          .catch(function () {
            dialog.close();
            window.location.href = link.href;
          })
          .then(function () {
            loading = false;
            body.setAttribute('aria-busy', 'false');
          });
      }

      function open() {
        dialog.showModal();
        document.documentElement.classList.add('is-dialog-open');
        load();
      }

      link.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });

      closeButton.addEventListener('click', function () {
        dialog.close();
      });

      /* 面の外（backdrop）を押したら閉じる。面の中の要素は target が dialog にならない */
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('is-dialog-open');
        link.focus();
      });
    });
  }

  function init(root) {
    setupClamp(root);
    setup(root);
    markCurrent(root);
    setupGallery(root);
    setupGuide(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    setupGallery(document);
  });
})();
